import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import './customTooltip.scss'

const CustomTooltip = ({content, children}) => {
  const renderTooltip = (props) => (<Tooltip {...props}>{content}</Tooltip>);

  return (
    <OverlayTrigger placement="auto-end" overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  )
}

export default CustomTooltip;